import { Button } from '@giftsay/ui';
import { LogOut, ShieldAlert } from 'lucide-react';

import { signOut } from '../../features/auth/services/firebase-auth.js';
import { useAppSelector } from '../../store/hooks.js';

/** What a vendor owner or staff login sees while their store is suspended (see AdminShell). */
export function StoreSuspendedNotice() {
  const email = useAppSelector((state) => state.auth.user?.email);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 px-4 py-12">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
        <div className="mx-auto mb-5 flex size-14 items-center justify-center rounded-full bg-destructive/10">
          <ShieldAlert className="size-7 text-destructive" />
        </div>
        <h1 className="text-xl font-semibold">Your store is suspended</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          The Giftsay team has temporarily suspended this store. While it&apos;s suspended your
          storefront is hidden from shoppers and no new orders can be placed.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          If you think this is a mistake or want to get your store back online, please contact the
          Giftsay team. This page updates by itself as soon as your store is reactivated.
        </p>
        {email ? (
          <p className="mt-5 text-xs text-muted-foreground">
            Signed in as <span className="font-medium text-foreground">{email}</span>
          </p>
        ) : null}
        <Button variant="outline" className="mt-4 w-full" onClick={() => void signOut()}>
          <LogOut className="mr-2 size-4" />
          Sign out
        </Button>
      </div>
    </div>
  );
}
